import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CategoryText = styled(Typography)<{ $isActive: boolean }>(
  ({ theme, $isActive }) => ({
    fontWeight: $isActive ? 700 : 500,
    color: $isActive
      ? theme.palette.text.primary
      : theme.palette.text.secondary,
  })
);
